(function ($) {
  Drupal.behaviors.anr_repromote_quiz_v1 = {
    attach: function (context) {
      $('#anr_repromote_mod5', context).once(function (idx, element) {
        const $thismodule = $(element);
        const triggerMod = '#anr_repromote_mod5';
        const thisModuleName = 'anr_repromote_mod5';
        const controller = new ScrollMagic.Controller();
        const moduleWillFade = $thismodule.data('scrollmagic') === 1;
        const $startQuiz = $thismodule.find('.js-anr__quiz-btnStart');
        const $quizQuestionSection = $thismodule.find('.js-anr__quiz-qs');
        const $eachQuestionSection = $quizQuestionSection.find('.js-anr__quiz-q');
        const $theFirstQuestion = $quizQuestionSection.find('.js-anr__quiz-q-1');
        const $options = $thismodule.find('.js-anr__quiz-option');
        const $nextBtn = $thismodule.find('.js-anr__quiz-btnNext');
        const $closeBtn = $thismodule.find('.js-anr__quiz-close');
        const $ansBtn = $thismodule.find('.js-anr__quiz-btnAns');
        const $resultsSection = $thismodule.find('.js-anr__quiz-results');
        const $resultReturned = $resultsSection.find('.js-anr__quiz-result');
        const $resetQuizOptions = $thismodule.find('.js-anr__quiz-option');
        const $questionsHeader = $thismodule.find('.js-anr__quiz-questionHeader');
        const allQuizOptions = '.js-anr__quiz-option';
        const quizQuestions = '.js-anr__quiz-q';
        const singleOptFlag = 'anr__quiz-tempInactive';
        let theQuizCounter = 10;
        let parentIndex, optionIndex, counterDirection;
        const urlHash = window.location.href.split('#')[1];
        let hasFaded = false;
        let offset, fadeThisModuleScene;
        const windowHeight = $(window).height();
        const parallaxDuration = windowHeight / 4;
        let tweenParallaxVal;

        if ($(window).width() < 768) {
          tweenParallaxVal = '-2.7%';
        } else {
          tweenParallaxVal = '-3.5%';
        }

        const optionClickVals = [
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: 0
              },
              {
                value: 1
              }
            ]
          },
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              }
            ]
          },
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: 1
              }
            ]
          },
          {
            values: [
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: -1
              },
              {
                value: 1
              }
            ]
          }
        ];

        // If module is called in URL, scroll to module.
        if (urlHash === thisModuleName) {
          $('html,body').animate(
            {
              scrollTop: $thismodule.offset().top - 85
            },
            1500
          );
        }
        if (window.location.href.indexOf('beauty_sleep_quiz') > -1) {
          $('html, body').animate(
            {
              scrollTop: $quizQuestionSection.offset().top - 150
            },
            1500,
            'easeInOutQuad'
          );
          $startQuiz.trigger('click');
        }

        // Hide and push down the module if it is to be faded in.
        if (moduleWillFade) {
          $thismodule.addClass('hideModules');
        }

        // Handle module fade-in from CMS.
        function fadeThisModule() {
          if (hasFaded === false) {
            hasFaded = true;
            $thismodule.animate(
              {
                opacity: 1,
                paddingTop: '0'
              },
              350,
              'easeOutQuad'
            );
          } else {
            return;
          }
        }

        // Parallaxing the quiz landing bg.
        new ScrollMagic.Scene({
          triggerElement: triggerMod,
          offset: 0,
          duration: parallaxDuration
        })
          .setTween('.anr__quiz-landingBg', 8, {
            marginTop: tweenParallaxVal,
            ease: Linear.easeNone
          })
          .addTo(controller);

        // Begin the quiz
        $startQuiz.on('click', function () {
          if (!$startQuiz.hasClass('quiz_active')) {
            $startQuiz.addClass('quiz_active');
            $questionsHeader.fadeIn();
            $quizQuestionSection.slideDown();
            $('html, body').animate(
              {
                scrollTop: $quizQuestionSection.offset().top - 150
              },
              1500,
              'easeInOutQuad'
            );
          }
        });

        // Close & restart the quiz.
        $closeBtn.on('click', function () {
          $quizQuestionSection.slideUp(function () {
            $startQuiz.removeClass('quiz_active');
            $eachQuestionSection.add($resultsSection).fadeOut();
            $resultsSection.removeClass('active');
            $resetQuizOptions.removeClass('button--dark active inactive').addClass('button--light');
            $nextBtn.addClass('anr__quiz-btnInactive');
            $theFirstQuestion.fadeIn();
            theQuizCounter = 10;
          });
        });

        // When a button is deactivated.
        function inactiveOption(which) {
          which.removeClass('button--light').addClass('button--dark active');
          which.siblings('button').removeClass('anr__quiz-btnInactive');
        }

        // When a button is activated.
        function activeOption(which) {
          which.removeClass('button--dark active').addClass('button--light');
          if (!which.siblings(allQuizOptions).hasClass('active')) {
            which.siblings('button').addClass('anr__quiz-btnInactive');
          }
        }

        // Increment/ decrement counter
        function counterValueDirection(which) {
          if (which.hasClass('active')) {
            counterDirection = 'decrement';
            activeOption(which);
          } else {
            counterDirection = 'increment';
            inactiveOption(which);
          }
        }

        // Check if this is a single-option question
        function checkWrapper(which) {
          if (which.parent().hasClass('js-anr__quiz-singleOpt')) {
            if (which.hasClass(singleOptFlag)) {
              which.removeClass(singleOptFlag);
              which.siblings().not('button').addClass(singleOptFlag);
            } else {
              which.siblings().not('button').addClass(singleOptFlag);
            }
          }
          counterValueDirection(which);
        }

        // Handle the score incrementation/decrementation.
        function incrementOptions(parentIndex, optionIndex, counterDirection) {
          parentIndex = parentIndex - 1;
          if (counterDirection === 'increment') {
            theQuizCounter =
              theQuizCounter + optionClickVals[parentIndex].values[optionIndex].value;
          } else {
            theQuizCounter =
              theQuizCounter - optionClickVals[parentIndex].values[optionIndex].value;
          }
        }

        // Clicking on the answers.
        $options.on('click', function () {
          const $this = $(this);

          if ($this.hasClass(singleOptFlag)) {
            $this.siblings('.active').trigger('click');
          }
          parentIndex = $(this).parent().parent(quizQuestions).index() + 1;
          optionIndex = $this.index();
          checkWrapper($this);
          incrementOptions(parentIndex, optionIndex, counterDirection);
        });

        // Clicking to the next set of questions.
        $nextBtn.on('click', function () {
          $(this).closest($eachQuestionSection).fadeOut().next().delay(200).fadeIn();
        });

        // Returning the score and showing the score view.
        $ansBtn.on('click', function () {
          $eachQuestionSection.add($questionsHeader).fadeOut();
          $resultsSection.delay(200).fadeIn().addClass('active');
          if (theQuizCounter < 3) {
            theQuizCounter = 3;
          }
          $resultReturned.text(theQuizCounter);
        });

        $(window).on('load', function () {
          // Content-Author-managed - Module Fade.
          if (moduleWillFade) {
            // Put in window load so that the page height is ready
            // by the time we get to animating.
            if ($thismodule.data('offset')) {
              offset = $thismodule.data('offset');
            } else {
              offset = 0;
            }

            // Init scrollMagic Scene Class
            fadeThisModuleScene = new ScrollMagic.Scene({
              triggerElement: triggerMod,
              offset: offset
            }).on('start', function () {
              fadeThisModule();
            });
            controller.addScene([fadeThisModuleScene]);
          }
        });
      });
    }
  };
})(jQuery);
